import { Component, Input, OnInit } from '@angular/core';
import { TopPurchase } from '@app/customer-reporting/models/top-purchases.model';
import { PlatformService } from '@panamax/app-state';
import { Product } from '@shared/models/product.model';
import { ProductService } from '@shared/services/product/product.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-top-purchases-card',
  templateUrl: './top-purchases-card.component.html',
  styleUrls: ['./top-purchases-card.component.scss'],
})
export class TopPurchasesCardComponent implements OnInit {
  @Input() purchase: TopPurchase;
  @Input() sortBy: 'Dollars' | 'Cases' = 'Dollars';
  product$: Observable<Product>;

  constructor(
    public platformService: PlatformService,
    private productService: ProductService,
  ) {}

  ngOnInit() {
    // Load product data into state
    this.productService.loadProduct(Number(this.purchase?.productID));
    // Get product from state
    this.product$ = this.productService.getProduct(
      Number(this.purchase?.productID),
    );
  }
}
